import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@honda-canada/design-system-react';
import { selectCurrentDrawerState, setCurrentDrawerState } from '../../core/reducers/ui';
import themeStyles from './DrawerToggle.styles';
import useSwipe from './useSwipe';
import isSSR from '../../utils/isSSR';
import { useAppSelector } from '../../core/utils';
import { selectBodyTypesForGtm, selectCurrentVehicleFromVehicles } from '../../core/reducers/vehicles';
import gtmForGenericBapEvent from '../../core/gtm/gtmForGenericBapEvent';
const DrawerContainer = themeStyles.apply(Box, 'DrawerContainer');
const Content = themeStyles.apply(Box, 'Content');
const HandleWrapper = themeStyles.apply(Box, 'HandleWrapper');
const Handle = themeStyles.apply('button', 'Handle');
const DrawerToggle = ({ children, ariaLabel = 'drag-button', dataTestId = 'drawer-toggle-container', handleState, }) => {
    const currentDrawerState = useAppSelector(selectCurrentDrawerState);
    const dispatch = useDispatch();
    const [drawerState, setDrawerState] = useState(handleState !== null && handleState !== void 0 ? handleState : currentDrawerState);
    const drawerRef = useRef(null);
    const gtmBodyStyle = useAppSelector(selectBodyTypesForGtm);
    const currentVehicle = useAppSelector(selectCurrentVehicleFromVehicles);
    const handleToggleDrawer = () => {
        gtmForGenericBapEvent({
            eventName: `customization_drawer ${drawerState === 'full' ? 'down' : 'up'}`,
            model: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.modelName,
            trim: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimName,
            gtmBodyStyle,
        });
        setDrawerState(prev => (prev === 'full' ? 'half' : 'full'));
        dispatch(setCurrentDrawerState(drawerState === 'full' ? 'half' : 'full'));
        if (!isSSR()) {
            window.scrollTo(0, 0);
        }
    };
    const swipeHandlers = useSwipe({
        onSwipe: handleToggleDrawer,
        setDrawerState,
        drawerRef,
    });
    return (_jsxs(DrawerContainer, { type: drawerState, ref: drawerRef, id: ariaLabel, "data-testid": dataTestId, children: [_jsx(HandleWrapper, { onClick: handleToggleDrawer, ...swipeHandlers, type: drawerState, children: _jsx(Handle, { "aria-labelledby": ariaLabel }) }), _jsx(Content, { children: children })] }));
};
export default DrawerToggle;
